export default "__VITE_ASSET__a89285b0__"